import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const CLUBoundaryIcon = withSvgIcon(
    <g>
        <path d="M461.9 269.2V96.3H500V0h-96.3v38.1H97.5V0H1.3v96.3h38.1V403.8H0V500h96.3v-38.2H403.8V500H500v-96.3h-38.1V269.2zM423.8 20H480v56.3h-56.3l.1-56.3zM21.3 76.3V20h56.3v56.3H21.3zm55 403.7H20v-56.3h56.3V480zM480 423.8V480h-56.3v-56.3l56.3.1zm-38.1-20h-38.1v38H96.3v-38H59.4V96.1h38.1v-38h306.4v38.1H442V403.8h-.1z" />
    </g>
);
